import { etapaSimulacaoTag, pageViewTag } from "./index";
import { pageTitlesNames } from "./constants";
import useUserStore from "../../storeModules/useUserStore";

const simulationStageByStep = {
  carrega_categorias: pageTitlesNames.home,
  pergunta_nome: pageTitlesNames.escolhaDeBem,
  saudacao_nome: pageTitlesNames.nome,
  mensagem_lista_planos: pageTitlesNames.credito,
  mensagem_email: pageTitlesNames.renda,
  pergunta_celular: pageTitlesNames.email,
  registra_lead: pageTitlesNames.celular,
  erro_renda_insuficiente: pageTitlesNames.rendaInsuficiente,
  renda_extra_confirmada: pageTitlesNames.rendaExtra,
  selecao_planos: pageTitlesNames.planos,
  confirmacao_informacoes: pageTitlesNames.planoSelecionado,
  nome_completo: pageTitlesNames.titular,
  cep: pageTitlesNames.nomeCpf,
  revisao_dados_pessoais: pageTitlesNames.dataNascimento,
  exibe_dados_cadastrais: pageTitlesNames.resumo,
};

const etapaSimulacaoTagHelper = (stepName) => {
  const simulationStage = simulationStageByStep[stepName];

  if (!Object.prototype.hasOwnProperty.call(simulationStageByStep, stepName)) {
    return;
  }

  pageViewTag();
  etapaSimulacaoTag(simulationStage);
};

export default etapaSimulacaoTagHelper;
